/**
 * แปลง delta เดือนนี้ vs เดือนก่อนเป็น badge ที่อ่านแล้วไม่เข้าใจผิด (P-SA69-1)
 *
 * - เดือนนี้ไม่มีอะไรเกิดขึ้น → "—" สีกลาง ไม่ใช่ ▼100% แดง ซึ่งอ่านเหมือนยอดรวมบนการ์ดหายไป
 * - เดือนก่อนเป็น 0 → หารศูนย์ คิด % ไม่ได้ แสดง "ใหม่" แทน ▲0% เขียวที่ดูเหมือนไม่มีอะไรเปลี่ยน
 * - นอกนั้นแสดง % จริงพร้อมทิศทาง
 *
 * KD3 S2376: ย้ายจาก DashboardPageV2 มาเป็น util กลาง — /reports/dashboard ยังใช้ percent_change ดิบ
 * (ฐาน 0 → "↑ 0%") จึงต้องใช้ตัวเดียวกัน
 */
export type DeltaBadgeTone = 'up' | 'down' | 'neutral';

export const computeDeltaBadge = (
  delta: { current: number; previous: number }
): { tone: DeltaBadgeTone; text: string } => {
  const { current, previous } = delta;
  if (current === 0) return { tone: 'neutral', text: '—' };
  if (previous === 0) return { tone: 'neutral', text: 'ใหม่' };
  const percent = Math.round(((current - previous) / previous) * 100);
  return { tone: percent >= 0 ? 'up' : 'down', text: `${Math.abs(percent)}%` };
};

/**
 * ข้อความสำหรับโปรแกรมอ่านหน้าจอ — ทิศทางของ badge บอกด้วยไอคอนลูกศร + สีเท่านั้น (KD3 S2464 NFR-DASH-004)
 * "522%" เฉยๆ ไม่รู้ว่าขึ้นหรือลง · "—" (เดือนนี้ไม่มีรายการ) ไม่มีอะไรให้อ่าน → ''
 */
export const deltaBadgeSpeech = (badge: { tone: DeltaBadgeTone; text: string }): string => {
  if (badge.tone === 'up') return `เพิ่มขึ้น ${badge.text}`;
  if (badge.tone === 'down') return `ลดลง ${badge.text}`;
  return badge.text === '—' ? '' : badge.text;
};
